import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

// Packages
import Emoji from 'react-emoji-render';
import { Helmet } from 'react-helmet';

// API
import * as API  from '../../../utils/api';

// Actions
import {
  updateForm,
} from '../../../actions/onboarding';

import {
  updateUserState,
} from '../../../actions/user';

// Components
import FormInput from '../../../components/Global/Forms/FormInput';
import SchoolSearchAutocompleteInput from '../../../components/Global/Forms/SchoolSearchAutocompleteInput';
import SelectFormInput from '../../../components/Global/Forms/SelectFormInput';
import SplitInputContainer from '../../../components/Global/Forms/SplitInputContainer';
import RadioFormInput from '../../../components/Global/Forms/RadioFormInput';
import AppCanvasLoader from '../../../components/Global/AppCanvasLoader';
import FlashMessage from '../../../components/Global/FlashMessage';

// Utils - Data
import stateDataAbbreviations from '../../../utils/data/stateAbbreviations.json';

class AthleteInfo extends Component {

  state = {
    input: {
      first_name: '',
      last_name: '',
      username: '',
      schoolId: '',
      graduation_year: '',
      sex: '',
      physique_height_feet: '',
      physique_height_inches: '',
      physique_weight: '',
      twitter: '',
      facebook:'',
      hudl: '',
      new_school_name: '',
      new_school_street_address: '',
      new_school_city: '',
      new_school_state: '',
      new_school_zip: '',
    },
    formErrors: {
      first_name: '',
      last_name: '',
      username: '',
      schoolId: '',
      graduation_year: '',
      sex: '',
      physique_height_feet: '',
      physique_height_inches: '',
      physique_weight: '',
      twitter: '',
      facebook:'',
      hudl: '',
      new_school_name: '',
      new_school_street_address: '',
      new_school_city: '',
      new_school_state: '',
      new_school_zip: '',
    },
    options: {
      sex: [
        {value: '0', label: 'Male'},
        {value: '1', label: 'Female'},
      ],
      height_in_feet: [
        {value: 3, label: "3'"},
        {value: 4, label: "4'"},
        {value: 5, label: "5'"},
        {value: 6, label: "6'"},
        {value: 7, label: "7'"},
      ],
      height_in_inches: [
        {value: 0, label: '0"'},
        {value: 1, label: '1"'},
        {value: 2, label: '2"'},
        {value: 3, label: '3"'},
        {value: 4, label: '4"'},
        {value: 5, label: '5"'},
        {value: 6, label: '6"'},
        {value: 7, label: '7"'},
        {value: 8, label: '8"'},
        {value: 9, label: '9"'},
        {value: 10, label: '10"'},
        {value: 11, label: '11"'},
      ],
      graduation_years: [],
    },
    currentlyAddingSchool: false,
    displayErrorMessages: false,
    formIsValid: false,
    usernameIsValid: '',
    yearOptions: [],
    isLoading: true,
    isSubmitting: false,
    athleteNamePrepopulated: false,
  }

  componentDidMount() {
    const { updateReduxUser, onboarding } = this.props;
    const {
      athlete_first_name,
      athlete_last_name,
    } = onboarding
    const { input } = this.state

    if (athlete_first_name && athlete_last_name) {
      this.setState({
        athleteNamePrepopulated: true,
        input: {
          ...input,
          first_name: athlete_first_name,
          last_name: athlete_last_name,
        }
      })
    }

    this.setInitialState();
    updateReduxUser({
      isOnboarding: true
    })
  }

  componentWillReceiveProps() {
    this.setInitialState();
  }

  setInitialState() {
    this.getGraduationYearOptions();

    this.setState(state => ({
      ...state,
      options: {
        ...state.options,
        graduation_years: this.getGraduationYearOptions()
      },
      isLoading: false
    }))
  }

  getGraduationYearOptions() {
    let startingYear = (new Date()).getFullYear();
    let yearOptions = [];

    for (var i = 0; i < 10; i++) {
      yearOptions.push(
        {value: startingYear, label: startingYear}
      )
      startingYear += 1;
    }

    return yearOptions;
  }

  handleInputChange = (event) => {
    const { value, name } = event.target;

    this.setState(state => ({
      ...state,
      input: {
        ...state.input,
        [name]: value
      }
    }), () => { this.updateFieldErrorMessage(name, value) });
  }

  handleSchoolSelection = (school) => {
    let schoolId = school.id;

    this.setState(state => ({
      ...state,
      searching: false,
      input: {
        ...state.input,
        schoolId: schoolId
      }
    }), () => { this.updateFieldErrorMessage('schoolId', schoolId) } );
  }

  updateUsernameValidity = (username) => {
    let formErrors = this.state.formErrors;

    if (/[^\w.]/.test(username)) {
      formErrors.username = "Usernames may only contain letters, numbers, underscores, and periods"
      return
    }

    let usernameIsAvailable = '';

    if (username.length > 0) {
      API.checkUsername(username).then(response => {
        if (response.errors) {
          usernameIsAvailable = true
        } else {
          usernameIsAvailable = false;
        }

        formErrors.username = usernameIsAvailable
          ? ''
          : 'That username is already taken. Please try again';

        this.setState(state => ({
          ...state,
          formErrors,
          usernameIsValid: usernameIsAvailable
        }), () => this.turnOnErrorMessages());
      });
    } else {
      this.setState(state => ({
        ...state,
        usernameIsValid: ''
      }));
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { user, onboarding } = this.props
    const {
      invitee_email,
    } = onboarding
    const {
      input,
      currentlyAddingSchool,
    } = this.state;

    this.setState({ isSubmitting: true })

    if (this.isFormValid()) {
      let profileForSubmission = {
        first_name: input.first_name,
        last_name: input.last_name,
        facebook_username: input.facebook,
        graduating_year: input.graduation_year,
        height_us_feet: input.physique_height_feet,
        height_us_inches: input.physique_height_inches,
        hudl_username: input.hudl,
        school_id: input.schoolId,
        sex: input.sex,
        twitter_username: input.twitter,
        username: input.username,
        weight_lbs: input.physique_weight,
      }

      if (currentlyAddingSchool) {
        profileForSubmission.school_attributes = {
          school_name: input.new_school_name,
          address: input.new_school_street_address,
          city: input.new_school_city,
          state: input.new_school_state,
          zip: input.new_school_zip,
        }
      }

      API.createProfile(user, profileForSubmission)
      .then(response => {
        if (response.id) {
          // Add both athlete and parent emails as maintainers
          // of freshly created profile
          const maintainerEmails = [user.email, invitee_email]

          // Update onboarding redux state
           this.props.updateOnboardingForm({
            maintained_profile: {
              first_name: response.first_name,
              last_name: response.last_name,
              username: response.username,
            }
          })

          API.updateMaintainerEmails(
            user,
            response.username,
            maintainerEmails
          )
          .then(response => {
            if (response.errors) {
              this.setState({ isSubmitting: false });
              console.log('there was an error: ', response.errors);
            } else {
              this.props.handleFormChange('sport-selection', 'athlete-info')
            }
          })
        } else {
          this.setState({ isSubmitting: false })
        }
      });
    } else {
      console.log('there is an error...');
      this.setState({ isSubmitting: false });
      this.setFormErrorState();
    }
  }

  setFormErrorState = () => {
    const { input, displayErrorMessages } = this.state;

    Object.keys(input).map((field, i) => {
      return this.updateFieldErrorMessage(field, input[field])
    })

    if (!this.state.formIsValid && !displayErrorMessages) {
      this.toggleErrorMessages();
    }
  }

  turnOnErrorMessages() {
    this.setState(state => ({
      ...state,
      displayErrorMessages: true
    }));
  }

  toggleErrorMessages() {
    const { displayErrorMessages } = this.state;

    this.setState(state => ({
      ...state,
      displayErrorMessages: !displayErrorMessages
    }));
  }

  updateFieldErrorMessage = (fieldName, value) => {
    let formErrors = this.state.formErrors;

    switch(fieldName) {
      case 'username':
        formErrors.username = value.length > 0
          ? ''
          : 'Please enter a username';
        this.updateUsernameValidity(value);
        break;
      case 'schoolId':
        formErrors.schoolId = value.toString().length > 0
          ? ''
          : 'Please select a school';
        break;
      case 'graduation_year':
        formErrors.graduation_year = value.length > 0
          ? ''
          : 'Please select a graduation year';
        break;
      case 'sex':
        let sexValue = parseInt(value, 10);
        formErrors.sex = sexValue === 1 || sexValue === 0
          ? ''
          : 'Please complete this field'
          break;
      case 'facebook':
      case 'twitter':
      case 'hudl':
      case 'physique_weight':
        formErrors[fieldName] = '';
        break;
      default:
        formErrors[fieldName] = value.length > 0
          ? ''
          : 'Please complete this field';
        break;
    }

    this.setState(state => ({
      ...state,
      formErrors,
    }));
  }

  isFormValid() {
    const {
      input,
      currentlyAddingSchool,
    } = this.state;

    let inputErrorIndex = Object.keys(input).map((field, i) => {
      if (currentlyAddingSchool && field === 'schoolId') {
        return true;
      } else if (!currentlyAddingSchool && field.includes('new_school_')) {
        return true;
      } else {
        return this.isFieldValid(field, input[field])
      }
    }).indexOf(false)

    if (inputErrorIndex > -1) {
      return false;
    } else {
      return true;
    }
  }

  isFieldValid = (fieldName, value) => {
    switch(fieldName) {
      case 'facebook':
      case 'twitter':
      case 'hudl':
      case 'physique_weight':
        return true;
        // eslint-disable-next-line no-unreachable
        break;
      case 'schoolId':
        return value.toString().length > 0
        // eslint-disable-next-line no-unreachable
        break;
      default:
        return value.length > 0
        // eslint-disable-next-line no-unreachable
        break;
    }
  }

  getUsernameFieldValidity = (usernameIsValid) => {
    if (usernameIsValid === true) {
      return ' valid';
    } else if (usernameIsValid === false) {
      return ' invalid';
    } else {
      return '';
    }
  }

  renderSchoolSelectionInputs() {
    const {
      currentlyAddingSchool,
      input,
      formErrors,
      displayErrorMessages,
    } = this.state;

    return currentlyAddingSchool
    ? (
      <div className="add-school">
        <div className="athlete-info-school-header">
          <label>
            Add a High School
          </label>
          <p>
            <a
              className="text-link"
              onClick={this.toggleAdditionalSchoolFields}
            >
              Cancel
            </a>
          </p>
        </div>
        <hr/>
        <FormInput
          label="School Name"
          placeholder="School Name"
          name="new_school_name"
          type="text"
          value={input.new_school_name}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.new_school_name}
        />
        <FormInput
          label="Street Address"
          placeholder="Street Address"
          name="new_school_street_address"
          type="text"
          value={input.new_school_street_address}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.new_school_street_address}
        />
        <SplitInputContainer
          showErrors={displayErrorMessages}
          errorMessages={[formErrors.new_school_city, formErrors.new_school_state, formErrors.new_school_zip]}
        >
          <FormInput
            optionalClasses="add-school-secondary-address-city"
            label="City"
            placeholder="City"
            name="new_school_city"
            type="text"
            value={input.new_school_city}
            onChange={this.handleInputChange}
            showError={displayErrorMessages}
            errorMessage={formErrors.new_school_city}
          />
          <SelectFormInput
            optionalClasses="add-school-secondary-address-state"
            label="State"
            placeholder="--"
            name="new_school_state"
            type="select"
            value={input.new_school_state}
            onChange={this.handleInputChange}
            errorMessage={formErrors.new_school_state}
            selectOptions={stateDataAbbreviations}
            showError={displayErrorMessages}
          />
          <FormInput
            optionalClasses="add-school-secondary-address-zip"
            label="Zip"
            placeholder="Zip"
            name="new_school_zip"
            type="number"
            value={input.new_school_zip}
            onChange={this.handleInputChange}
            showError={displayErrorMessages}
            errorMessage={formErrors.new_school_zip}
          />
        </SplitInputContainer>
        <hr/>
      </div>
    )
    : (
      <div>
        <div className="athlete-info-school-header">
          <label htmlFor="school">
            High School
          </label>
          <p>
            Not listed?&nbsp;
            <a
              className="text-link"
              onClick={this.toggleAdditionalSchoolFields}
            >
              Add a School
            </a>
          </p>
        </div>
        <SchoolSearchAutocompleteInput
          schoolSearchType='high school'
          onChange={(selectedSchool) => this.handleSchoolSelection(selectedSchool)}
          showError={displayErrorMessages}
          errorMessage={formErrors.schoolId}
        />
        <p className="smaller note">Don't see your school? Type the full name of your high school followed by city and state.</p>
      </div>
    )
  }

  toggleAdditionalSchoolFields = () => {
    this.setState(state => ({
      ...state,
      currentlyAddingSchool: !this.state.currentlyAddingSchool
    }));
  }

  renderFormStep() {
    const { role } = this.props.user;

    return role === 'parent'
    ? ( <p> Step 3 of 5 </p> )
    : ( <p> Step 2 of 4 </p> )
  }

  render() {
    const {
      input,
      formErrors,
      displayErrorMessages,
      usernameIsValid,
      isLoading,
      options,
      isSubmitting,
      athleteNamePrepopulated,
    } = this.state;
    const { appName, viaLogin, onboarding, user } = this.props;
    const { role, maintained_profiles } = user;
    const { athlete_first_name, athlete_last_name } = onboarding;

    if (maintained_profiles.length > 0) {
      return (
        <Redirect to={{
          pathname: '/'
        }}/>
      )
    }

    return isLoading
    ? (
      <AppCanvasLoader />
    )
    : (
      <div className="onboarding-athlete-info">
        <Helmet>
          <title>{appName} | Create Athlete Profile</title>
        </Helmet>
        {
          (role === 'athlete' && !viaLogin) &&
          <FlashMessage>
            <Emoji text=":trophy: Your account was successfully created!" />
          </FlashMessage>
        }
        {
          viaLogin &&
          <FlashMessage>
            Welcome back to Locker Linked! To finish getting you on board, please finish creating your profile.
          </FlashMessage>
        }
        <header>
          {this.renderFormStep()}
          <h2>
            Create Athlete Profile
          </h2>
        </header>
        <form
          onSubmit={this.handleSubmit}
          className="athlete-info-form"
        >
          {
            role === 'parent' && athleteNamePrepopulated &&
            <div className="prefilled-athlete-name">
              <div className="info-block">
                <label>
                  First Name
                </label>
                <p>
                  {athlete_first_name}
                </p>
              </div>
              <div className="info-block">
                <label>
                  Last Name
                </label>
                <p>
                  {athlete_last_name}
                </p>
              </div>
            </div>
          }
          <FormInput
            label="Choose a Username"
            placeholder="Username"
            name="username"
            type="text"
            value={input.username}
            onChange={this.handleInputChange}
            optionalClasses={`validate-container${this.getUsernameFieldValidity(usernameIsValid)}`}
            showError={displayErrorMessages}
            errorMessage={formErrors.username}
          >
            <p className="note">Once selected, your unique username cannot be changed, and will be used as a custom Locker Linked url. lockerlinked.com/{input.username}</p>
          </FormInput>
          {this.renderSchoolSelectionInputs()}
          <SelectFormInput
            label="Graduating Year"
            name="graduation_year"
            type="select"
            value={input.graduation_year}
            placeholder="Select a Year..."
            onChange={this.handleInputChange}
            errorMessage={formErrors.graduation_year}
            optionalClasses="select-container"
            selectOptions={options.graduation_years}
            showError={displayErrorMessages}
          />
          <RadioFormInput
            label="Sex"
            name="sex"
            selectedOption={input.sex}
            showError={displayErrorMessages}
            errorMessage={formErrors.sex}
            onChange={this.handleInputChange}
            options={options.sex}
            optionalClasses="radio-containers-half"
          />
          <SplitInputContainer
            showErrors={displayErrorMessages}
            errorMessages={
              [
                formErrors.physique_height_feet,
                formErrors.physique_height_inches
              ]
            }
          >
            <SplitInputContainer
              label="Height"
            >
              <SelectFormInput
                name="physique_height_feet"
                type="select"
                value={input.physique_height_feet}
                onChange={this.handleInputChange}
                errorMessage={formErrors.physique_height_feet}
                optionalClasses="select-container"
                placeholder="Ft."
                selectOptions={options.height_in_feet}
              />
              <SelectFormInput
                name="physique_height_inches"
                type="select"
                value={input.physique_height_inches}
                onChange={this.handleInputChange}
                errorMessage={formErrors.physique_height_inches}
                optionalClasses="select-container"
                placeholder="In."
                selectOptions={options.height_in_inches}
              />
            </SplitInputContainer>
            <FormInput
              label="Weight in Lbs (optional)"
              placeholder="Enter Weight"
              name="physique_weight"
              type="number"
              value={input.physique_weight}
              onChange={this.handleInputChange}
            />
          </SplitInputContainer>
          {
            isSubmitting
            ? <div className="spinner" />
            : (
              <input
                type="submit"
                value="Continue"
              />
            )
          }
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    onboarding: state.onboarding,
    schools: state.schools,
    user: state.user,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateOnboardingForm: formData => {
      dispatch(updateForm(formData))
    },
    updateReduxUser: (user) => dispatch(updateUserState(user)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AthleteInfo)



// WEBPACK FOOTER //
// ./src/screens/Onboarding/Forms/AthleteInfo.js